import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { authAPI } from "../api";
import AuthShell from "../components/AuthShell";
import Button from "../components/atoms/Button";
import { Field, InputWithIcon, inputStyle, ErrorBox } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || "No account found with this email.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell
      quote={<>A reset link, then you're back at <em>Day 1.</em></>}
      attribution="The fix"
    >
      {sent ? (
        <div>
          <Mail size={36} strokeWidth={1.5} color="var(--ink-700)" />
          <h1 className="font-display" style={{ fontSize: 44, lineHeight: 1.05, fontWeight: 400, letterSpacing: "-0.025em", margin: "16px 0 8px" }}>
            Check your <em style={{ color: "var(--gold-500)" }}>inbox.</em>
          </h1>
          <p style={{ color: "var(--fg-2)", fontSize: 15, lineHeight: 1.6, margin: "0 0 28px" }}>
            We sent a fresh link to <strong style={{ color: "var(--fg-1)" }}>{email}</strong>. It expires in an hour.
          </p>
          <Link to="/login" style={{ color: "var(--gold-700)", fontWeight: 600, textDecoration: "none", borderBottom: "1px solid currentColor", fontSize: 14 }}>
            ← Back to sign in
          </Link>
        </div>
      ) : (
        <>
          <h1 className="font-display" style={{ fontSize: 48, lineHeight: 1.05, fontWeight: 400, letterSpacing: "-0.025em", margin: "0 0 8px" }}>
            Forgot it <em style={{ color: "var(--gold-500)" }}>happens.</em>
          </h1>
          <p style={{ color: "var(--fg-3)", fontSize: 15, margin: "0 0 28px" }}>
            Tell us your email — we'll send a fresh sign-in link.
          </p>

          {error && <ErrorBox>{error}</ErrorBox>}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Field id="email" label="Email">
              <InputWithIcon icon={<Mail size={18} strokeWidth={1.5} />}>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle} autoFocus />
              </InputWithIcon>
            </Field>

            <Button type="submit" variant="primary" disabled={loading} style={{ width: "100%", justifyContent: "center" }}>
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>

          <p style={{ marginTop: 28, color: "var(--fg-3)", fontSize: 14, textAlign: "center" }}>
            <Link to="/login" style={{ color: "var(--gold-700)", fontWeight: 600, textDecoration: "none", borderBottom: "1px solid currentColor" }}>
              ← Back to sign in
            </Link>
          </p>
        </>
      )}
    </AuthShell>
  );
}
